/**
 * Chart Rendering Colors Configuration
 * Централизованная утилита для получения цветов из системы пресетов
 * Following CLAUDE.md - все константы в /src/config/
 * 
 * NOTE: Все цвета теперь управляются через систему пресетов в chartColorPresets.ts
 */

import { chartColorPresetManager } from './chartColorPresets';

/**
 * Функция для получения цвета по типу элемента из ТЕКУЩЕГО АКТИВНОГО пресета
 */
export function getElementColor(elementType: 'planet' | 'lagna' | 'hora' | 'chandra'): string {
  const currentPreset = chartColorPresetManager.getCurrentPreset();
  switch (elementType) {
    case 'lagna': return currentPreset.elements.lagna;
    case 'hora': return currentPreset.elements.hora;
    case 'chandra': return currentPreset.elements.chandra;
    default: return currentPreset.elements.planetDefault;
  }
}